import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchShiftPrograms } from './operationsSlice'
import { OperationsTabBar } from './components/OperationsTabBar'
import {
  OpsPageWrapper,
  OpsGrid,
  ShiftProgramCard,
  ShiftProgramName,
  ShiftProgramMeta,
  ShiftProgramStats,
  Badge,
  OpsButton,
  opsColors,
} from './styled/Operations.styled'

export const ShiftProgramList: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { shiftPrograms } = useSelector((state: RootState) => state.operations)

  useEffect(() => {
    dispatch(fetchShiftPrograms())
  }, [dispatch])

  return (
    <OpsPageWrapper>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: '30px', fontWeight: 900, color: opsColors.textPrimary, margin: 0, fontFamily: 'DM Sans, sans-serif' }}>
          Shift Programs
        </h1>
        <OpsButton onClick={() => navigate('/ops-control/shift-programs/create')}>
          + Create Shift Program
        </OpsButton>
      </div>

      <OperationsTabBar />

      <OpsGrid columns="1fr 1fr" gap="1rem">
        {shiftPrograms?.map((program) => (
          <ShiftProgramCard key={program.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <ShiftProgramName>{program.name}</ShiftProgramName>
              <Badge bg={program.status === 'Active' ? opsColors.successBase : opsColors.warningBase}>
                {program.status}
              </Badge>
            </div>
            <ShiftProgramMeta>
              {program.departmentName} &middot; {program.shiftNames.join(', ')}
            </ShiftProgramMeta>
            <ShiftProgramStats>
              <div>
                <div style={{ fontSize: '18px', fontWeight: 800, color: opsColors.textPrimary }}>{program.tasksPerShift}</div>
                <div style={{ fontSize: '10px', textTransform: 'uppercase', color: opsColors.textFaded }}>Tasks/Shift</div>
              </div>
              <div>
                <div style={{ fontSize: '18px', fontWeight: 800, color: opsColors.textPrimary }}>{program.workersNeeded}</div>
                <div style={{ fontSize: '10px', textTransform: 'uppercase', color: opsColors.textFaded }}>Workers</div>
              </div>
              <div>
                <div style={{ fontSize: '12px', color: opsColors.textFaded }}>
                  Last run: {program.lastRun ? new Date(program.lastRun).toLocaleString() : '-'}
                </div>
              </div>
            </ShiftProgramStats>
          </ShiftProgramCard>
        ))}
      </OpsGrid>
    </OpsPageWrapper>
  )
}
